import { render, staticRenderFns } from "./MobilePreview.vue?vue&type=template&id=12d92304&scoped=true&"
import script from "./MobilePreview.vue?vue&type=script&lang=js&"
export * from "./MobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreview.vue?vue&type=style&index=0&id=12d92304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d92304",
  null
  
)

export default component.exports